export default __webpack_public_path__ + "static/media/dot.233ca936.svg";